'use client';

import { useEffect, useState } from 'react';

// 첫 화면 리소스를 다 받은 뒤를 알린다.
// 화면에 가까워질 때까지 기다렸다 받으면 폰에서는 여유가 300px(반 화면도 안 된다)
// 뿐이라, 스크롤해 내려온 시점에 영상이 아직 비어 있다.
export function useAfterPageLoad(fallbackMs = 4000) {
  const [afterLoad, setAfterLoad] = useState(false);

  useEffect(() => {
    if (document.readyState === 'complete') {
      setAfterLoad(true);
      return;
    }
    const done = () => setAfterLoad(true);
    window.addEventListener('load', done, { once: true });
    // 서드파티 스크립트가 늦으면 load 도 같이 밀리므로 상한을 둔다.
    const timer = window.setTimeout(done, fallbackMs);
    return () => {
      window.removeEventListener('load', done);
      window.clearTimeout(timer);
    };
  }, [fallbackMs]);

  return afterLoad;
}
